import script from "./AdminRolesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminRolesPage.vue?vue&type=script&setup=true&lang=js"

import "./AdminRolesPage.vue?vue&type=style&index=0&id=490aa8b4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-490aa8b4"]])

export default __exports__